/* ============================================================
   GESABAS — Main Script v6 (Dynamic Shopify products)
   ============================================================ */

const CDN = 'https://cdn.shopify.com/s/files/1/0757/7370/6432/files/';

/* ── Color detection from product title ── */
const COLOR_MAP = [
  { key: 'gris',     hex: '#888888' },
  { key: 'noir',     hex: '#111111' },
  { key: 'blanc',    hex: '#EBEBEB' },
  { key: 'fourrure', hex: '#ADADAA' },
  { key: 'vichy',    hex: '#1a1a1a' },
  { key: 'beige',    hex: '#C8B89A' },
  { key: 'camel',    hex: '#C19A6B' },
  { key: 'ecru',     hex: '#F5F0E8' },
  { key: 'creme',    hex: '#F5F0E8' },
  { key: 'rouge',    hex: '#8B0000' },
  { key: 'bordeaux', hex: '#5C0A20' },
  { key: 'bleu',     hex: '#1a3a5c' },
  { key: 'vert',     hex: '#2d4a2d' },
  { key: 'rose',     hex: '#d4a0a0' },
  { key: 'marron',   hex: '#5c3a1e' },
];

function getColor(title) {
  const lower = title.toLowerCase();
  for (const { key, hex } of COLOR_MAP) {
    if (lower.includes(key)) return hex;
  }
  return '#888888';
}

function getColorName(title) {
  const lower = title.toLowerCase();
  for (const { key } of COLOR_MAP) {
    if (lower.includes(key)) return key.charAt(0).toUpperCase() + key.slice(1);
  }
  return 'Couleur';
}

function getCategory(tags) {
  const list = Array.isArray(tags)
    ? tags.map(t => t.trim().toLowerCase())
    : (tags || '').split(',').map(t => t.trim().toLowerCase());
  if (list.includes('bas')) return 'bas';
  if (list.includes('accessoire')) return 'accessoire';
  return 'haut';
}

function stripHtml(html) {
  return (html || '').replace(/<[^>]*>/g, '').trim();
}

/* ── Dynamic product loading ── */
const variantMap = {};
let PRODUCTS = [];

async function loadProducts() {
  const grid = document.getElementById('productGrid');
  if (grid) grid.innerHTML = '<p style="padding:40px 32px;color:#a09e9b;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;">Chargement...</p>';

  try {
    const res = await fetch('/products.json?limit=250');
    if (!res.ok) throw new Error('Fetch failed');
    const data = await res.json();

    const groups = {};

    data.products.forEach(product => {
      if (!product.product_type) return;

      variantMap[product.handle] = {};
      product.variants.forEach(v => {
        const size = v.option1 || v.title;
        variantMap[product.handle][size] = v.id;
      });

      const type = product.product_type.toUpperCase();
      const category = getCategory(product.tags);

      if (!groups[type]) {
        groups[type] = {
          id: type.toLowerCase().replace(/\s+/g, '-'),
          ref: type,
          category,
          variants: []
        };
      }

      const imgs = (product.images || []).map(i => i.src);
      const price = parseFloat(product.variants[0]?.price || 0);
      const sizes = product.variants
        .map(v => v.option1 || v.title)
        .filter(s => s !== 'Default Title');

      groups[type].variants.push({
        id:            product.id,
        name:          product.title,
        colorName:     getColorName(product.title),
        color:         getColor(product.title),
        price,
        shopifyHandle: product.handle,
        sizes:         sizes.length > 0 ? sizes : ['ONE SIZE'],
        img:           imgs[0] || '',
        img2:          imgs[1] || imgs[0] || '',
        images:        imgs,
        desc:          stripHtml(product.body_html)
      });
    });

    PRODUCTS = Object.values(groups);
  } catch(e) {
    console.error('Erreur chargement produits:', e);
    if (grid) grid.innerHTML = '<p style="padding:40px 32px;color:#a09e9b;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;">Impossible de charger les produits.</p>';
  }
}

/* ── Helpers ── */
const fmt = n => '€' + Number(n).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/* ── DOM ── */
const $cartSidebar = document.getElementById('cartSidebar');
const $cartOverlay = document.getElementById('cartOverlay');
const $cartToggle  = document.getElementById('cartToggle');
const $cartClose   = document.getElementById('cartClose');
const $cartItems   = document.getElementById('cartItems');
const $cartFooter  = document.getElementById('cartFooter');
const $cartCount   = document.getElementById('cartCount');
const $cartTotal   = document.getElementById('cartTotal');

/* ── Cart sidebar ── */
function openCart() {
  $cartSidebar?.classList.add('open');
  $cartOverlay?.classList.add('active');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  $cartSidebar?.classList.remove('open');
  $cartOverlay?.classList.remove('active');
  document.body.style.overflow = '';
}

$cartToggle?.addEventListener('click', openCart);
$cartClose?.addEventListener('click', closeCart);
$cartOverlay?.addEventListener('click', closeCart);

/* ── Shopify cart API ── */
async function renderCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const count = cart.item_count;
    const total = cart.total_price / 100;

    if ($cartCount) $cartCount.textContent = count > 0 ? count : '';
    if ($cartTotal) $cartTotal.textContent = fmt(total);
    if (!$cartItems) return;

    if (cart.items.length === 0) {
      $cartItems.innerHTML = '<p class="cart-empty">Votre panier est vide.</p>';
      if ($cartFooter) $cartFooter.style.display = 'none';
      return;
    }

    if ($cartFooter) $cartFooter.style.display = 'block';

    $cartItems.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-variant-id="${item.variant_id}">
        <div class="cart-item-img">
          <img src="${item.image}" alt="${item.product_title}" loading="lazy">
        </div>
        <div>
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-size">${item.variant_title !== 'Default Title' ? 'Taille ' + item.variant_title : ''}</div>
          <div class="cart-item-price">${fmt(item.price / 100)}</div>
        </div>
        <button class="cart-item-remove" aria-label="Retirer">✕</button>
      </div>
    `).join('');

    $cartItems.querySelectorAll('.cart-item-remove').forEach(btn => {
      const row = btn.closest('.cart-item');
      btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(row.dataset.variantId), quantity: 0 })
        });
        renderCart();
      });
    });
  } catch(e) {
    console.error('Cart render error:', e);
  }
}

async function addToCart(variant, size) {
  const handle = variant.shopifyHandle;
  if (!handle) { alert('Ce produit n\'est pas encore disponible.'); return; }

  const sizeMap = variantMap[handle];
  if (!sizeMap) { console.warn('Product not loaded:', handle); return; }

  const variantId = sizeMap[size] || Object.values(sizeMap)[0];
  if (!variantId) { console.warn('No variant ID found for', handle, size); return; }

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });
  await renderCart();
  openCart();
}

/* ── Product card ── */
function createCard(group) {
  const card = document.createElement('div');
  card.className = 'product-card reveal';

  let activeIdx = 0;

  const render = () => {
    const v = group.variants[activeIdx];
    card.innerHTML = `
      <div class="product-card-img">
        <img class="img-front" src="${v.img}" alt="${v.name}" loading="lazy">
        <img class="img-back"  src="${v.img2 || v.img}" alt="${v.name}" loading="lazy">
        <div class="product-quickadd">Voir le produit</div>
      </div>
      <div class="product-card-meta">
        <span class="product-name">${group.ref}</span>
        <span class="product-price">${fmt(v.price)}</span>
      </div>
      ${group.variants.length > 1 ? `
        <div class="product-swatches">
          ${group.variants.map((vv, i) => `
            <button class="swatch${i === activeIdx ? ' active' : ''}" style="background:${vv.color}" data-idx="${i}" title="${vv.colorName}"></button>
          `).join('')}
        </div>
      ` : ''}
    `;

    card.querySelectorAll('.swatch').forEach(sw => {
      sw.addEventListener('click', e => {
        e.stopPropagation();
        activeIdx = parseInt(sw.dataset.idx);
        render();
      });
    });

    card.querySelector('.product-quickadd').addEventListener('click', e => {
      e.stopPropagation();
      openModal(group, activeIdx);
    });
  };

  card.onclick = () => openModal(group, activeIdx);
  render();
  return card;
}

/* ── Product grid + filters ── */
function initProducts() {
  const grid = document.getElementById('productGrid');
  if (!grid) return;

  function render(filter) {
    grid.innerHTML = '';
    const list = filter === 'all' ? PRODUCTS : PRODUCTS.filter(p => p.category === filter);
    list.forEach((p, i) => {
      const card = createCard(p);
      card.classList.add(`reveal-d${(i % 4) + 1}`);
      grid.appendChild(card);
    });
    initReveal();
  }

  render('all');

  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      render(btn.dataset.filter);
    });
  });
}

/* ── Modal ── */
let activeModal = null;

function openModal(group, variantIdx = 0) {
  closeModal();

  const modal = document.createElement('div');
  modal.className = 'product-modal';
  document.body.appendChild(modal);

  let activeVariantIdx = variantIdx;

  const init = () => {
    const v = group.variants[activeVariantIdx];
    const hasGallery = v.images && v.images.length > 1;

    modal.innerHTML = `
      <div class="product-modal-overlay"></div>
      <div class="product-modal-inner">
        <div class="product-modal-img">
          <button class="modal-close modal-close-img" aria-label="Fermer">✕</button>
          <img id="modalMainImg" src="${v.img}" alt="${v.name}">
          ${hasGallery ? `
            <button class="gallery-arrow gallery-prev" id="galleryPrev" aria-label="Photo précédente">
              <svg viewBox="0 0 48 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="5" x2="44" y2="5" stroke="white" stroke-width="1"/>
                <polyline points="38,0 48,5 38,10" stroke="white" stroke-width="1" fill="none" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="gallery-arrow gallery-next" id="galleryNext" aria-label="Photo suivante">
              <svg viewBox="0 0 48 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="5" x2="44" y2="5" stroke="white" stroke-width="1"/>
                <polyline points="38,0 48,5 38,10" stroke="white" stroke-width="1" fill="none" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="gallery-counter" id="galleryCounter">01 — ${String(v.images.length).padStart(2,'0')}</div>
          ` : ''}
        </div>
        <div class="product-modal-details">
          <button class="modal-close" aria-label="Fermer">✕</button>
          <div class="modal-product-ref">${group.ref}</div>
          <div class="modal-product-title">${v.name}</div>
          <div class="modal-product-price">${fmt(v.price)}</div>
          ${group.variants.length > 1 ? `
            <div class="modal-swatches">
              ${group.variants.map((vv, i) => `
                <button class="swatch modal-swatch${i === activeVariantIdx ? ' active' : ''}" style="background:${vv.color}" data-idx="${i}" title="${vv.colorName}"></button>
              `).join('')}
            </div>
          ` : ''}
          <div class="modal-divider"></div>
          <p class="modal-product-desc">${v.desc}</p>
          <span class="size-label">Choisir une taille</span>
          <div class="size-grid">${v.sizes.map(s => `<button class="size-btn" data-size="${s}">${s}</button>`).join('')}</div>
          <p class="size-error" id="sizeError">Veuillez sélectionner une taille.</p>
          <button class="btn-add-to-cart" id="modalAddBtn">Ajouter au panier</button>
        </div>
      </div>
    `;

    let selectedSize = null;

    modal.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        modal.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selectedSize = btn.dataset.size;
        modal.querySelector('#sizeError')?.classList.remove('visible');
      });
    });

    modal.querySelector('#modalAddBtn')?.addEventListener('click', async () => {
      if (!selectedSize) { modal.querySelector('#sizeError')?.classList.add('visible'); return; }
      closeModal();
      await addToCart(v, selectedSize);
    });

    modal.querySelectorAll('.modal-swatch').forEach(sw => {
      sw.addEventListener('click', () => {
        activeVariantIdx = parseInt(sw.dataset.idx);
        init();
      });
    });

    modal.querySelector('.product-modal-overlay').addEventListener('click', closeModal);
    modal.querySelectorAll('.modal-close').forEach(btn => btn.addEventListener('click', closeModal));

    if (hasGallery) {
      let current = 0;
      let isAnimating = false;
      const imgZone = modal.querySelector('.product-modal-img');
      const counter = modal.querySelector('#galleryCounter');

      imgZone.querySelector('#modalMainImg').src = v.images[0];

      const slide = () => {
        if (isAnimating) return;
        isAnimating = true;
        counter.textContent = `${String(current + 1).padStart(2,'0')} — ${String(v.images.length).padStart(2,'0')}`;
        const oldImg = imgZone.querySelector('#modalMainImg');
        const newImg = document.createElement('img');
        newImg.src = v.images[current];
        newImg.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;z-index:1;';
        imgZone.appendChild(newImg);
        newImg.getBoundingClientRect();
        newImg.style.transition = 'opacity 700ms ease';
        newImg.style.opacity = '1';
        setTimeout(() => { oldImg.remove(); newImg.id = 'modalMainImg'; newImg.style.zIndex = ''; isAnimating = false; }, 700);
      };

      modal.querySelector('#galleryPrev').addEventListener('click', () => {
        current = (current - 1 + v.images.length) % v.images.length;
        slide();
      });
      modal.querySelector('#galleryNext').addEventListener('click', () => {
        current = (current + 1) % v.images.length;
        slide();
      });

      let touchStartX = 0;
      imgZone.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
      imgZone.addEventListener('touchend', e => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) { current = (current + 1) % v.images.length; slide(); }
          else { current = (current - 1 + v.images.length) % v.images.length; slide(); }
        }
      }, { passive: true });
    }
  };

  init();

  const scrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  if (window.innerWidth <= 680) {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  }
  modal._scrollY = scrollY;
  requestAnimationFrame(() => modal.classList.add('open'));
  document.addEventListener('keydown', onEsc);
  activeModal = modal;
}

function closeModal() {
  if (!activeModal) return;
  activeModal.classList.remove('open');
  const m = activeModal;
  setTimeout(() => m.remove(), 380);
  const scrollY = m._scrollY || 0;
  activeModal = null;
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollY);
  document.removeEventListener('keydown', onEsc);
}

const onEsc = e => { if (e.key === 'Escape') closeModal(); };

/* ── Scroll reveal ── */
function initReveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.06 });
  document.querySelectorAll('.reveal:not(.visible)').forEach(el => io.observe(el));
}

/* ── Contact form ── */
function initContact() {
  const form = document.getElementById('contactForm');
  if (!form) return;
  form.addEventListener('submit', e => {
    e.preventDefault();
    const btn = form.querySelector('.btn-black');
    btn.textContent = 'Message envoyé ✓';
    btn.style.opacity = '0.6';
    btn.disabled = true;
  });
}

/* ── Hero slideshow ── */
function initHero() {
  const heroImg = document.getElementById('heroImg');
  if (!heroImg) return;
  const slides = [CDN+'hero-1.jpg', CDN+'hero-2.jpg'];
  let current = 0;
  setInterval(() => {
    current = (current + 1) % slides.length;
    heroImg.style.opacity = '0';
    setTimeout(() => { heroImg.src = slides[current]; heroImg.style.opacity = '1'; }, 600);
  }, 4000);
  heroImg.style.transition = 'opacity 0.6s ease';
}

/* ── Brand teaser slideshow (uses product images dynamically) ── */
function initTeaser() {
  const wrap = document.querySelector('.brand-teaser-img');
  if (!wrap) return;
  const slides = wrap.querySelectorAll('.teaser-slide');
  if (slides.length < 2) return;

  const pool = PRODUCTS.flatMap(g => g.variants.flatMap(v => v.images)).filter(Boolean);
  if (pool.length < 2) return;

  let current = 0, poolIdx = 0;
  const shuffle = arr => arr.map(v => ({ v, s: Math.random() })).sort((a,b) => a.s-b.s).map(x=>x.v);
  let shuffled = shuffle(pool);

  slides[0].src = shuffled[0];
  slides[0].classList.add('active');

  setInterval(() => {
    const next = 1 - current;
    poolIdx = (poolIdx + 1) % shuffled.length;
    if (poolIdx === 0) shuffled = shuffle(pool);
    slides[next].src = shuffled[poolIdx];
    slides[next].onload = () => {
      slides[next].classList.add('active');
      slides[current].classList.remove('active');
      current = next;
    };
  }, 5000);
}

/* ── Hamburger ── */
function initHamburger() {
  const btn  = document.getElementById('navHamburger');
  const menu = document.getElementById('mobileNav');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => {
    btn.classList.toggle('open');
    menu.classList.toggle('open');
  });
  menu.querySelectorAll('.mobile-nav-link').forEach(link => {
    link.addEventListener('click', () => {
      btn.classList.remove('open');
      menu.classList.remove('open');
    });
  });
}

/* ── Preload first product images ── */
function preloadImages() {
  PRODUCTS.slice(0, 4).forEach(p => {
    const v = p.variants[0];
    if (v.img)  { const i = new Image(); i.src = v.img; }
    if (v.img2) { const i = new Image(); i.src = v.img2; }
  });
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', async () => {
  await loadProducts();
  renderCart();
  initHero();
  initProducts();
  preloadImages();
  initTeaser();
  initContact();
  initHamburger();
  setTimeout(initReveal, 100);
});
